import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useSubscriptionCheck from '../../common/SubscriptionCheck';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { CREATE_PROFORMA_INVOICE } from '../../../constants/eInvoicePermissions';
import { useAccessDeniedMessage } from '../../../hooks/useAccessDeniedMessage';
import PermissionDeniedWrapper from '../../../components/PermissionDeniedWrapper';

function ProformaInvoiceListPageActions() {
  const navigate = useNavigate();
  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();
  const { hasEInvoicePermission } = usePermissions();
  const accessDeniedMessage = useAccessDeniedMessage();
  const { proformaInvoices: pi } = useTranslatedMessages();
  const canCreate = hasEInvoicePermission(CREATE_PROFORMA_INVOICE);

  const handleCreateAction = () => {
    if (!canCreate || !checkSubscription()) {
      return;
    }
    return navigate('/sales/proforma-invoices/create');
  };

  return (
    <>
      <PermissionDeniedWrapper show={!canCreate} title={accessDeniedMessage}>
        <Button
          id="create-proforma-invoice"
          key="create-new-proforma-invoice"
          variant="contained"
          color="primary"
          onClick={handleCreateAction}
          disabled={!canCreate}
        >
          {pi?.list_actions?.create_new ?? '+ Create Proforma Invoice'}
        </Button>
      </PermissionDeniedWrapper>
      <SubscriptionModal />
    </>
  );
}

export default ProformaInvoiceListPageActions;
